import type { ReactNode } from "react";

import { useController, useGame } from "../context";

export function Chip({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      className={active ? "chip chip--active" : "chip"}
      aria-pressed={active}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export function Toast() {
  const controller = useController();
  const toast = useGame((s) => s.toast);
  if (!toast) return null;
  return (
    <div className="toast" role="status" onClick={() => controller.dismissToast()}>
      {toast}
    </div>
  );
}

/** Полоска «связь потеряна»: только пока идёт переподключение в комнате. */
export function ConnectionStrip() {
  const connection = useGame((s) => s.connection);
  const inRoom = useGame((s) => s.session?.kind === "room");
  const lost =
    connection?.state === "reconnecting" ||
    (connection?.state === "connecting" && connection.attempt > 0);
  if (!inRoom || !lost) return null;
  return (
    <div className="conn-strip" role="status">
      Связь потеряна. Переподключаемся…
    </div>
  );
}

export function Stepper({ index, total }: { index: number; total: number }) {
  const current = Math.min(index + 1, total);
  const percent = total === 0 ? 0 : (current / total) * 100;
  return (
    <div className="stepper">
      <div className="stepper__bar">
        <div className="stepper__fill" style={{ width: `${percent}%` }} />
      </div>
      <span className="stepper__text">
        {current} / {total}
      </span>
    </div>
  );
}
